/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { ShipmentActivityResponse } from "../models/index";
import {
  ShipmentActivityResponseFromJSON,
  ShipmentActivityResponseToJSON,
} from "../models/index";

export interface GetActivityRequest {
  shipmentId: string;
}

/**
 *
 */
export class ShipmentActivityApi extends runtime.BaseAPI {
  /**
   */
  async getActivityRaw(
    requestParameters: GetActivityRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ShipmentActivityResponse>> {
    if (requestParameters["shipmentId"] == null) {
      throw new runtime.RequiredError(
        "shipmentId",
        'Required parameter "shipmentId" was null or undefined when calling getActivity().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/shipment-activity/{shipmentId}`.replace(
          `{${"shipmentId"}}`,
          encodeURIComponent(String(requestParameters["shipmentId"])),
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ShipmentActivityResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async getActivity(
    requestParameters: GetActivityRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ShipmentActivityResponse> {
    const response = await this.getActivityRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
